import { markiereJavaScriptAktiv } from './js-aktiv';
import { kopierenEinrichten } from './kopieren';
import { ergebnisErsetzen, htmlLaden, sucheEinrichten } from './suche';
import { teilenEinrichten } from './teilen';
import { anzeigenEinrichten } from './verdeckt';

markiereJavaScriptAktiv(document.documentElement);

// UC-018: Knöpfe «Teilen» auf den Seiten für Besucher
document.querySelectorAll<HTMLElement>('[data-teilen]').forEach((bereich) => teilenEinrichten(bereich));

// UC-019: Adresse des Feeds kopieren; UC-023: API-Anleitung bzw. API-Token kopieren
document.querySelectorAll<HTMLElement>('[data-kopieren]').forEach((bereich) => kopierenEinrichten(bereich));

// UC-023 A2: verdecktes API-Token anzeigen
document.querySelectorAll<HTMLElement>('[data-anzeigen]').forEach((knopf) => anzeigenEinrichten(document, knopf));

// UC-017: Suchfeld in der Kopfzeile; auf der Seite der Volltextsuche ersetzt die Suche nur die Trefferliste
const suche = document.querySelector<HTMLFormElement>('#suche');
if (suche) {
  const oeffnen = (adresse: string): void => window.location.assign(adresse);
  let ablage: Storage | null = null;
  try {
    ablage = sessionStorage;
  } catch {
    // Ohne Ablage geht nur der Fokus beim Öffnen der Volltextsuche verloren
  }
  sucheEinrichten(suche, {
    oeffnen,
    ersetzen: document.querySelector('#suchergebnis') ? ergebnisErsetzen(document, htmlLaden, oeffnen) : undefined,
    ablage,
  });
}
